import React from 'react';

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

import { Users, UserPlus, Shield, AlertTriangle, Calendar, Key, Settings, Bell, TrendingUp, Activity, BarChart3, FileText, Globe, Zap, Building, Building2, CreditCard, Database, FolderOpen, Layers, Calculator, BookOpen, Video, DollarSign, Package, Handshake, Receipt, Mail, User, FileSignature, Home, HardDrive, Gift, Megaphone, Landmark, QrCode, Award, History, Recycle } from 'lucide-react';

import BackButton from '../../components/BackButton';
import { Printer } from 'lucide-react';
import PrintInstitutionalFrame from '../../components/PrintInstitutionalFrame';
import '../../styles/print-institutional.css';

// Import des composants Phase 3

import LanguageSelector from '../../components/LanguageSelector';
import NotificationBell from '../../components/NotificationBell';
import AdminAccountRecoveryModal from '../../components/AdminAccountRecoveryModal';

// Import des nouveaux composants Pro

import HelpCenterV2 from '../../components/HelpCenterV2';
import WelcomeTour from '../../components/WelcomeTour';

// FTPERegistreAdherentsAdmin: module SUPPRIMÉ (26/05/2026).

const _BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Onglets du dashboard
const TABS = [
  { id: 'overview', label: 'Vue d\'ensemble', icon: BarChart3 },
  { id: 'validation-manuelle', label: 'Majorations personnalisées', icon: Award },
  { id: 'kpi-dashboard', label: '📈 KPIs', icon: TrendingUp },
  { id: 'analytics', label: '📊 Analytics', icon: TrendingUp },
  { id: 'announcements', label: '📢 Annonces', icon: Megaphone },
  { id: 'ftpe-adhesions', label: '🏢 Adhésions FTPE', icon: Building },
  { id: 'ftpe-virements', label: '🏦 Validation Virements', icon: Landmark },
  { id: 'registres-custom', label: '📚 Registres Custom', icon: BookOpen },
  { id: 'released-accounts', label: '♻️ Comptes libérés', icon: History },
  { id: 'funnels-events', label: '🎯 Funnels & Events', icon: Activity },
  { id: 'conventions-paiements', label: '💳 Conventions Payantes', icon: CreditCard },
  { id: 'stripe-notifications', label: '🔔 Notifications Stripe', icon: CreditCard },
  { id: 'stats-activites', label: 'Activités souscrites', icon: BarChart3 },
  { id: 'communications-section', label: 'COMMUNICATION & ALERTES', isSeparator: true },
  { id: 'alertes-virements', label: '🔔 Alertes Virements', icon: Bell },
  { id: 'alertes-echeances', label: 'Alertes Echeances', icon: Mail },
  { id: 'email-tracking', label: 'Suivi Emails', icon: Mail },
  { id: 'email-preview', label: '✉️ Aperçu Emails', icon: Mail },
  { id: 'demandes-partenariat', label: '🤝 Partenariats', icon: Handshake },
  { id: 'demandes-remises', label: '♻️ Demandes remises', icon: Recycle },
  { id: 'partenariats-section', label: 'COMPTES, PLANS & CRÉDITS', isSeparator: true },
  { id: 'identifiants', label: '🔑 Identifiants', icon: Key },
  { id: 'plans', label: '📦 Plans', icon: Package },
  { id: 'subscription-types', label: '🏷️ Types de souscription', icon: Layers },
  { id: 'factures-plans', label: '💼 Factures Plans (PADH-)', icon: FileText },
  { id: 'propositions-signees', label: '✍️ Propositions signées', icon: FileSignature },
  { id: 'suivi-signatures', label: '✍️ Suivi des signatures', icon: FileSignature },
  { id: 'registre-pcs', label: '📜 Registre PCS (ESS)', icon: Award },
  { id: 'seuils-echelonnement', label: '💳 Seuils SEPA échelonnés', icon: CreditCard },
  { id: 'registre-fiscal', label: '⚖️ Registre Fiscal', icon: FileText },
  { id: 'registre-maitres-ouvrage', label: "🏗️ Registre Maîtres d'ouvrage", icon: FileText },
  { id: 'registre-adherents-ftpe', label: '🏢 Registre Adhérents FTPE', icon: FileText },
  { id: 'credits', label: '🪙 Crédits', icon: CreditCard },
  { id: 'credits-guide-cms', label: '📖 Guide Crédits (CMS)', icon: BookOpen },
  { id: 'audit-credits', label: '📋 Audit Crédits', icon: Shield },
  { id: 'bonus-programmes', label: '🎁 Bonus Programmés', icon: Gift },
  { id: 'promotions', label: '⚡ Promos Flash', icon: Zap },
  { id: 'gestion-membres', label: 'Création Membres', icon: UserPlus },
  { id: 'comptes-test', label: '🧪 Comptes de test', icon: UserPlus, externalRoute: '/admin/comptes-test' },
  { id: 'export-stats', label: '📊 Export & Stats', icon: TrendingUp },
  { id: 'ged-section', label: 'GED & DOCUMENTATION', isSeparator: true },
  { id: 'backups', label: '💾 Backups', icon: HardDrive },
  { id: 'rgpd-zip-shares', label: '🛡️ Audit RGPD ZIP', icon: Shield },
  { id: 'rgpd-unified', label: '🛡️ Registre RGPD Unifié', icon: Shield },
  { id: 'ged-ess', label: 'GED ESS', icon: FolderOpen },
  { id: 'ged-statistiques', label: 'Statistiques GED', icon: BarChart3 },
  { id: 'cartographie', label: 'Cartographie', icon: Globe },
  { id: 'collections', label: 'Collections', icon: Database },
  { id: 'categories', label: 'Catégories', icon: FolderOpen },
  { id: 'nomenclatures', label: 'Nomenclatures', icon: BookOpen },
  { id: 'simulateurs-separator', label: '🎯 SIMULATEURS MAÎTRES', isSeparator: true },
  { id: 'simulateur-batico', label: '🧮 BATICO Calculateur', icon: Calculator },
  { id: 'simulateur-dos', label: 'DOS-DOMIUM', icon: Home },
  { id: 'cockpit-ccmi', label: '🏗️ Cockpit CCMI', icon: Building2, externalRoute: '/admin/ccmi-dashboard' },
  { id: 'gestion-financiere-domium', label: '💰 Gestion Financière DOMIUM', icon: CreditCard },
  { id: 'batico-config-advanced', label: '🚀 Config BATICO Avancée', icon: Settings },
  { id: 'coopers-experts', label: "COOPER'S & EXPERTS", icon: Building },
  { id: 'suivi-section', label: 'SUIVI & TRAÇABILITÉ', isSeparator: true },
  { id: 'rappels-dashboard', label: "🔔 Suivi Rappels", icon: Bell },
  { id: 'factures-recus', label: "Factures et reçus ESS", icon: Receipt },
  { id: 'suivi-rcds', label: 'Suivi RCDS', icon: Shield },
  { id: 'suivi-dos-domium', label: 'Suivi DOS DOMIUM', icon: Building2 },
  { id: 'tarifs-demandes', label: 'Tarifs Leads', icon: DollarSign },
  { id: 'conventions', label: 'Conventions Partenariat', icon: FileText },
  { id: 'videos', label: 'Vidéos', icon: Video },
  { id: 'operations-section', label: 'OPÉRATIONS & SYSTÈME', isSeparator: true },
  { id: 'export-import', label: 'Export/Import', icon: Database },
  { id: 'alerts', label: 'Alertes', icon: AlertTriangle },
  { id: 'agenda', label: 'Agenda', icon: Calendar },
  { id: 'roles', label: 'Rôles', icon: Shield },
  { id: 'assignments', label: 'Assignations', icon: Users },
  { id: 'messagerie', label: 'Messagerie', icon: Mail },
  { id: 'config-emails-clients', label: 'Config Emails Clients', icon: Mail },
  { id: 'journal-emails', label: 'Journal Emails', icon: Mail },
  { id: 'registre-qr', label: 'Registre QR Codes', icon: QrCode },
  { id: 'code-health', label: '⚙️ Code Health', icon: Activity },
  { id: 'nav-config', label: '🧭 Navigation (onglets)', icon: Layers, externalRoute: '/admin/navigation-config' },
  { id: 'frontoffice-nav', label: '🧭 Menus front-office', icon: Layers },
  { id: 'frontoffice-footer', label: '🦶 Pied de page', icon: Layers },
  { id: 'profil', label: 'Mon Profil', icon: User }
];

import { useSuperAdmin } from './useSuperAdmin';
import SuperAdminViews from './SuperAdminViews';

export default function SuperAdminDashboard() {
  const ctx = useSuperAdmin();
  const { activeTab, admins, handleCreateAssignment, loading, navigate, selectedAdmin, selectedUser, setActiveTab, setSelectedAdmin, setSelectedUser, setShowAccountRecovery, setShowAssignModal, showAccountRecovery, showAssignModal, t, unassignedUsers } = ctx;
  if (loading && activeTab === 'overview') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-6 px-3 sm:px-4" style={{ background: 'radial-gradient(circle at 0% 0%, #eef2fb 0%, #f8fafc 60%)' }} data-print-mode="institutional">
      <PrintInstitutionalFrame
        docTitle="Rapport de pilotage Super Admin"
        caption="Centre de contrôle"
        captionSecondary="Super Administrateur"
      />

      <div className="max-w-7xl mx-auto print-area">
        {/* Header institutionnel */}
        <div className="mb-6 relative overflow-hidden rounded-2xl border border-slate-200/60 shadow-xl print-keep-bg"
             data-tour="kpis"
             style={{ background: `radial-gradient(circle at 30% 0%, rgba(255,255,255,0.12), transparent 55%), linear-gradient(135deg, #0a1e3f 0%, #0B3C5D 55%, #0a1e3f 100%)` }}>
          <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl -translate-y-32 translate-x-32" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-amber-200 rounded-full blur-3xl translate-y-24 -translate-x-24" />
          </div>
          <div className="relative px-5 sm:px-7 py-5">
            <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
              <BackButton variant="dark" to="/admin/dashboard" label="Retour" />
              <div className="flex items-center gap-2">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => { try { window.print(); } catch {} }}
                  className="h-8 text-[12px] gap-1.5 bg-white/10 border-amber-300/40 text-amber-100 hover:bg-white/20 print-allow"
                  title="Imprimer ou exporter en PDF institutionnel (Ctrl+P)"
                  data-testid="print-institutional-btn"
                >
                  <Printer className="h-3.5 w-3.5" />
                  <span className="hidden sm:inline">Imprimer PDF officiel</span>
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => setShowAccountRecovery(true)}
                  className="h-8 text-[12px] gap-1.5 bg-white/10 border-rose-300/40 text-rose-100 hover:bg-rose-500/20"
                  title="Libérer ou reconstruire l'accès email d'un compte verrouillé"
                  data-testid="open-account-recovery-btn"
                >
                  <Shield className="h-3.5 w-3.5" />
                  <span className="hidden sm:inline">Libérer un accès</span>
                </Button>
                <LanguageSelector variant="compact" />
                <NotificationBell />
              </div>
            </div>
            {/* Filet officiel */}
            <div className="flex items-center gap-2 text-[10.5px] uppercase tracking-[0.22em] text-white/85 mb-3">
              <span className="inline-block w-7 h-px bg-amber-300/80" />
              <span className="font-semibold">O&apos;SCOP</span>
              <span className="text-white/40">|</span>
              <span>Centre de contrôle</span>
              <span className="text-white/40">|</span>
              <span>Accès Super Administrateur</span>
            </div>
            <div className="flex items-center gap-4 sm:gap-5">
              <div className="relative hidden sm:block flex-shrink-0">
                <div className="absolute inset-0 bg-amber-300/20 rounded-2xl blur-xl" />
                <div className="relative inline-flex items-center justify-center w-[60px] h-[60px] rounded-2xl bg-white/12 backdrop-blur-md border border-white/25 shadow-xl">
                  <Shield className="h-7 w-7 text-white drop-shadow-lg" />
                </div>
              </div>
              <div className="min-w-0">
                <h1 className="text-[clamp(1.6rem,2.7vw,2.2rem)] leading-[1.05] font-black tracking-tight text-white" style={{ fontFamily: '"Playfair Display", "Georgia", serif' }}>
                  {t('super_admin_dashboard.title', 'Super Admin')}
                </h1>
                <p className="text-[13px] text-white/80 mt-1 font-light">
                  {t('super_admin_dashboard.subtitle', 'Centre de contrôle et gestion avancée — accès complet aux dispositifs ESS')}
                </p>
              </div>
            </div>
            <div className="mt-4 h-px bg-gradient-to-r from-transparent via-amber-300/60 to-transparent" />
          </div>
        </div>

        {/* Navigation par onglets — densifiée + sections marquées */}
        <div className="mb-6 no-print">
          <div className="flex flex-wrap gap-1.5 bg-white/95 backdrop-blur-sm p-2 rounded-xl shadow-md border border-slate-200/70">
            {TABS.map((tab) => {
              // Gérer les séparateurs (sections institutionnelles)
              if (tab.isSeparator) {
                return (
                  <div key={tab.id} className="w-full mt-2 mb-1">
                    <div className="flex items-center gap-2">
                      <div className="h-px flex-1 bg-gradient-to-r from-transparent to-amber-400/60" />
                      <span className="px-3 py-1 text-[10.5px] uppercase tracking-[0.2em] font-bold text-slate-700 bg-gradient-to-r from-amber-50 to-amber-100/80 border border-amber-200 rounded-full shadow-sm">
                        {tab.label}
                      </span>
                      <div className="h-px flex-1 bg-gradient-to-l from-transparent to-amber-400/60" />
                    </div>
                  </div>
                );
              }
              const Icon = tab.icon;
              // Si c'est un lien vers une autre page
              if (tab.link) {
                return (
                  <Button
                    key={tab.id}
                    variant="outline"
                    size="sm"
                    onClick={() => navigate(tab.link)}
                    className="h-8 text-[12px] flex items-center gap-1.5 border-purple-300 text-purple-700 hover:bg-purple-50 hover:border-purple-400 transition-all"
                  >
                    {Icon && <Icon className="h-3.5 w-3.5" />}
                    {tab.label}
                  </Button>
                );
              }
              const active = activeTab === tab.id;
              // Si l'item a une `externalRoute`, on navigue vers cette URL
              // au lieu de juste changer d'onglet interne.
              const handleClick = tab.externalRoute
                ? () => navigate(tab.externalRoute)
                : () => setActiveTab(tab.id);
              return (
                <Button
                  key={tab.id}
                  variant={active ? 'default' : 'ghost'}
                  size="sm"
                  onClick={handleClick}
                  data-testid={`tab-${tab.id}`}
                  className={`h-8 text-[12px] flex items-center gap-1.5 transition-all ${
                    active
                      ? 'bg-gradient-to-r from-[#0B3C5D] to-[#0a1e3f] text-white shadow-md hover:from-[#0a3252] hover:to-[#091a36] border border-amber-300/30'
                      : 'text-slate-700 hover:bg-slate-100/80 hover:text-[#0B3C5D]'
                  }`}
                >
                  {Icon && <Icon className="h-3.5 w-3.5" />}
                  {tab.label}
                </Button>
              );
            })}
          </div>
        </div>

        {/* Contenu */}
        <SuperAdminViews ctx={ctx} />

        {/* Modal d'assignation */}
        {showAssignModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <Card className="w-full max-w-2xl max-h-[90vh] overflow-y-auto">
              <CardHeader>
                <CardTitle>{t('super_admin_dashboard.new_assignment', 'Nouvelle assignation')}</CardTitle>
                <CardDescription>{t('super_admin_dashboard.assign_user_to_admin', 'Assigner un utilisateur à un administrateur')}</CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                {/* Sélection de l'admin */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Sélectionner un admin *
                  </label>
                  <select
                    value={selectedAdmin}
                    onChange={(e) => setSelectedAdmin(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="" disabled>-- Choisir un admin --</option>
                    {admins.map(admin => (
                      <option key={admin.id} value={admin.id}>
                        {admin.nom} {admin.prenom} ({admin.email})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Sélection de l'utilisateur */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Sélectionner un utilisateur à assigner *
                  </label>
                  
                  {/* Membres */}
                  {unassignedUsers.members.length > 0 && (
                    <div className="mb-4">
                      <p className="text-xs text-gray-500 mb-2 font-medium">MEMBRES</p>
                      <select
                        value={selectedUser.type === 'member' ? selectedUser.id : ''}
                        onChange={(e) => setSelectedUser({ id: e.target.value, type: 'member' })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="" disabled>-- Choisir un membre --</option>
                        {unassignedUsers.members.map(member => (
                          <option key={member.id} value={member.id}>
                            {member.nom} {member.prenom} ({member.email})
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* COOPER&apos;S */}
                  {unassignedUsers.coopers.length > 0 && (
                    <div className="mb-4">
                      <p className="text-xs text-gray-500 mb-2 font-medium">COOPER&apos;S</p>
                      <select
                        value={selectedUser.type === 'cooper' ? selectedUser.id : ''}
                        onChange={(e) => setSelectedUser({ id: e.target.value, type: 'cooper' })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="" disabled>-- Choisir un COOPER&apos;S --</option>
                        {unassignedUsers.coopers.map(cooper => (
                          <option key={cooper.id} value={cooper.id}>
                            {cooper.entreprise || cooper.nom_entreprise} ({cooper.email})
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Experts */}
                  {unassignedUsers.experts.length > 0 && (
                    <div className="mb-4">
                      <p className="text-xs text-gray-500 mb-2 font-medium">EXPERTS</p>
                      <select
                        value={selectedUser.type === 'expert' ? selectedUser.id : ''}
                        onChange={(e) => setSelectedUser({ id: e.target.value, type: 'expert' })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="" disabled>-- Choisir un expert --</option>
                        {unassignedUsers.experts.map(expert => (
                          <option key={expert.id} value={expert.id}>
                            {expert.nom} {expert.prenom} ({expert.email})
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {unassignedUsers.members.length === 0 && 
                   unassignedUsers.coopers.length === 0 && 
                   unassignedUsers.experts.length === 0 && (
                    <p className="text-sm text-gray-500 py-4 text-center">
                      Tous les utilisateurs sont déjà assignés
                    </p>
                  )}
                </div>

                {/* Boutons */}
                <div className="flex gap-3 justify-end">
                  <Button
                    variant="outline"
                    onClick={() => {
                      setShowAssignModal(false);
                      setSelectedAdmin('');
                      setSelectedUser({ id: '', type: '' });
                    }}
                  >
                    Annuler
                  </Button>
                  <Button
                    onClick={handleCreateAssignment}
                    className="bg-blue-600 hover:bg-blue-700"
                  >
                    <UserPlus className="h-4 w-4 mr-2" />
                    Créer l&apos;assignation
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        )}
      </div>
      
      {/* Tour guidé de bienvenue */}
      <WelcomeTour space="super_admin" />
      
      {/* Centre d'aide amélioré */}
      <HelpCenterV2 space="super_admin" />

      {/* Modale "Libérer / reconstruire l'accès email" — super_admin only */}
      <AdminAccountRecoveryModal
        open={showAccountRecovery}
        onClose={() => setShowAccountRecovery(false)}
      />
    </div>
  );
}
